import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const SvgEditorAndroid: React.FC = () => (
  <SEOLandingPage
    title="SVG Editor for Android — PNG to SVG Converter & Cricut Export | Cosmovex"
    metaDescription="SVG Editor — Image to Vector for Android. Edit SVG files, convert PNG/JPG to SVG on-device, export Cricut-ready vectors, and work fully offline with 50+ templates."
    ogTitle="SVG Editor for Android — Image to Vector Converter & Cricut Export"
    h1="SVG Editor for Android"
    intro="Edit SVG files and convert photos to clean vector graphics — right on your Android phone. No subscription, no cloud upload, no laptop required."
    paragraphs={[
      "SVG Editor — Image to Vector is built for anyone who works with vector graphics on the go. Whether you need to tweak an SVG for a Cricut cut file, convert a PNG logo to a scalable vector, or build a design from scratch using the canvas editor, the app puts a full vector workflow on your phone.",
      "The image-to-SVG vectorizer is the standout feature. Import a PNG or JPG and the app traces it on-device, producing a clean SVG with adjustable color depth, path detail, and smoothness. The conversion happens locally — your images never leave your phone. This matters for business logos, hand-drawn sketches, and any artwork where privacy counts.",
      "Cricut users will find the export presets particularly useful. SVG files exported from the app are formatted for Cricut Design Space compatibility, with proper layer naming and path structure. Skip the conversion step that usually trips up Cricut projects and go straight from phone to cutting machine.",
      "The built-in SVG editor gives you a canvas to move, resize, rotate, and style elements. Add text, shapes, and paths. Use the templates gallery — 50+ prebuilt designs — to start fast, then customize. All edits happen offline. Your files stay on your device, and the app works just as well on a plane as it does on your couch.",
    ]}
    features={[
      "On-device PNG/JPG to SVG vectorizer — no upload needed",
      "Full SVG canvas editor with move, resize, and rotate",
      "Cricut-ready SVG export presets",
      "50+ templates gallery for quick starts",
      "Offline — works without internet connection",
      "Adjustable vectorization settings (colors, detail, smoothness)",
      "Layer management for complex designs",
      "Export SVG, PNG, and other formats",
      "Text and shape tools on the canvas",
      "Privacy-first: images processed entirely on your device",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.svgvedit"
    icon="/images/svgvedit.png"
    appName="SVG Editor — Image to Vector"
    accentColor="#A8720E"
    canonicalPath="/svg-editor-android"
  />
);

export default SvgEditorAndroid;
